const IconSparkle = ({ className, onClick, strokeWidth = '2', size = 24 }) => (
   <svg xmlns="http://www.w3.org/2000/svg" className={`icon icon-tabler icon-tabler-sparkles ${className}`} onClick={onClick} width={size} height={size} viewBox="0 0 24 24" stroke-width={strokeWidth} stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z"></path>
   </svg>
);

export default IconSparkle;